import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import Skeleton from "@material-ui/lab/Skeleton";

import EditIcon from "@material-ui/icons/Edit";

import { useStyles } from "../../../../../Components/CSS/DetailStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import { url } from "../../../../../Config/Config";
import Axios from "axios";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { publicImageUrl } from "../../../../../Config/publicImageUrl";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class DriverDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      driverDetails: {},
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getDetails(this.props.match.params.id);
    }
  }

  getDetails = async (driverId) => {
    try {
      const response = await Axios.get(`${url}/api/drivers/${driverId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.driver) {
        this.setState({ driverDetails: response.data.driver });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getDetails(driverId);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { driverDetails } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Driver Details"
            url={`/administration/driver/edit/${this.props.match.params.id}`}
            urlTitle="Edit Driver"
            icon={<EditIcon style={{ color: "#1f1f1f" }} />}
          />
          <div>
            <div>
              <div>Driver's Information</div>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Full Name:</b>
                <div>{driverDetails.driverFullName}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Address:</b>
                <div>{driverDetails.address}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Mobile Number:</b>
                <div>{driverDetails.mobileNumber}</div>
              </ListItem>
              {driverDetails.altMobileNumber && (
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Alternate Mobile Number:</b>
                  <div>{driverDetails.altMobileNumber}</div>
                </ListItem>
              )}
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Category:</b>
                <div>{driverDetails.category}</div>
              </ListItem>
            </div>
            <br />
            <div>Photos</div>
            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                lg={12}
                className={classes.gridContent}
              >
                <div>Driver Image</div>
                {driverDetails.image ? (
                  <img
                    src={`${publicImageUrl}/${driverDetails.image}`}
                    alt={driverDetails.driverFullName}
                    style={{ width: 300, height: 300 }}
                  />
                ) : (
                  <Skeleton variant="circle" width={200} height={200} />
                )}
              </Grid>
              <Grid container item xs={12} sm={12} md={12} xl={12} lg={12}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  xl={6}
                  lg={6}
                  className={classes.gridContent}
                >
                  <div>Citizenship Front</div>
                  {driverDetails.citizenshipFront ? (
                    <img
                      src={`${publicImageUrl}/${driverDetails.citizenshipFront}`}
                      alt={driverDetails.driverFullName}
                      style={{ width: 300, height: 300 }}
                    />
                  ) : (
                    <Skeleton variant="circle" width={200} height={200} />
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  xl={6}
                  lg={6}
                  className={classes.gridContent}
                >
                  <div>Citizenship Back</div>
                  {driverDetails.citizenshipBack ? (
                    <img
                      src={`${publicImageUrl}/${driverDetails.citizenshipBack}`}
                      alt={driverDetails.driverFullName}
                      style={{ width: 300, height: 300 }}
                    />
                  ) : (
                    <Skeleton variant="circle" width={200} height={200} />
                  )}
                </Grid>
              </Grid>
              <Grid container item xs={12} sm={12} md={12} xl={12} lg={12}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  xl={6}
                  lg={6}
                  className={classes.gridContent}
                >
                  <div>License Front</div>
                  {driverDetails.drivingLicenseFront ? (
                    <img
                      src={`${publicImageUrl}/${driverDetails.drivingLicenseFront}`}
                      alt={driverDetails.driverFullName}
                      style={{ width: 300, height: 300 }}
                    />
                  ) : (
                    <Skeleton variant="circle" width={200} height={200} />
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  xl={6}
                  lg={6}
                  className={classes.gridContent}
                >
                  <div>License Back</div>
                  {driverDetails.drivingLicenseBack ? (
                    <img
                      src={`${publicImageUrl}/${driverDetails.drivingLicenseBack}`}
                      alt={driverDetails.driverFullName}
                      style={{ width: 300, height: 300 }}
                    />
                  ) : (
                    <Skeleton variant="circle" width={200} height={200} />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(DriverDetails)));
